import { useSelector } from "react-redux";

import { useGetBooksQuery } from "../../features/api/apiSlice";
import BookLoader from "../UI/BookLoader";
import Error from "../UI/Error";
import BookItem from "./BookItem";

const BookList = () => {
  const { data: books, isLoading, isError } = useGetBooksQuery();

  const { status, text } = useSelector((state) => state.filter);

  const filteredByFeatured = (bookItem) => {
    if (status === "featured") return bookItem.featured;
    return bookItem;
  };

  const filteredBySearch = (bookItem) => {
    if (text.length > 0) {
      return bookItem.name.toLowerCase().includes(text.toLowerCase());
    }
    return bookItem;
  };

  // decide what to render
  let content = null;

  if (isLoading) {
    content = (
      <>
        <BookLoader />
        <BookLoader />
        <BookLoader />
      </>
    );
  }

  if (!isLoading && isError) {
    content = <Error message="There was an error" />;
  }

  if (!isLoading && !isError && books?.length === 0) {
    content = <Error message="No videos found!" />;
  }

  if (!isLoading && !isError && books?.length > 0) {
    content = books
      .filter(filteredByFeatured)
      .filter(filteredBySearch)
      .map((book) => <BookItem key={book.id} book={book} />);
  }

  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {content}
    </div>
  );
};

export default BookList;
